export interface SignOffPendingUpdate {
  lessonId: string;
  level: SignOffLevel;
}

export enum SignOffLevel {
  Class = 'class',
  Grade = 'grade',
  SchoolManagement = 'schoolManagement',
}
